// src/utils/countryCodes.js
export const COUNTRY_CODES = [
  { code: '+1', flag: '🇺🇸' },
  { code: '+44', flag: '🇬🇧' },
  { code: '+61', flag: '🇦🇺' },
  { code: '+33', flag: '🇫🇷' },
  { code: '+49', flag: '🇩🇪' },
  { code: '+81', flag: '🇯🇵' },
  { code: '+52', flag: '🇲🇽' },
  { code: '+91', flag: '🇮🇳' },
  { code: '+86', flag: '🇨🇳' },
  { code: '+7', flag: '🇷🇺' }
];

// helper function
export function getDefaultCountryCode() {
  return '+1'; // Default to US code
}

export function findCountryByCode(code) {
  return COUNTRY_CODES.find(c => c.code === code);
}